import React from 'react';
import PropType from 'prop-types';
import styled from 'styled-components';
import ModalTitle from './ModalTitle';
import Paragraph from '../Paragraph/Paragraph';
import { ReactComponent as Info } from '../../assets/images/svg/info.svg';
import themeColors from '../../assets/styles/themeColors';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';
import { uFlexColumn } from '../../assets/styles/utility';

const headerHeightMobile = pxToRemMd(74);

const getPopupSize = (size) => {
  if (size === 'sm') {
    return `
    max-width: ${pxToRem(390)};
    width: 100%;

  ${mediaBelow(variables.breakpoints.bpMd)} {
      margin: ${headerHeightMobile} auto ${headerHeightMobile};
      max-height: calc(100vh - (2 * ${headerHeightMobile}));
  }`;
  }

  if (size === 'md') {
    return `
    max-width: ${pxToRem(521)};
     width: 100%;
   

   ${mediaBelow(variables.breakpoints.bpMd)} {
       margin: ${headerHeightMobile} auto ${headerHeightMobile};
       max-height: calc(100vh - (2 * ${headerHeightMobile}));
   }`;
  }

  if (size === 'lg') {
    return `
        max-width: ${pxToRem(782)};
        width: 100%;`;
  }
};

export const PopupWrapper = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  ${({ size }) => getPopupSize(size)}

  ${mediaBelow(variables.breakpoints.bpMd)} {
    width: 100%;
    max-width: 100vw;
    margin: 0;
    min-height: 100%;
  }
`;

const PopupContainer = styled.div`
  ${uFlexColumn};
  align-items: ${({ alignItems }) => (alignItems ? `${alignItems}` : '')};
  height: 100%;
`;

const InfoIconWrap = styled.div`
  margin-bottom: ${pxToRem(8)};

  &,
  svg {
    width: ${pxToRem(48)};
    height: ${pxToRem(48)};
    fill: ${({ color }) => (color ? `${color}` : '')};
  }
`;
const ModalPopup = ({
  title,
  message,
  isPopupOpen,
  alignItems,
  size,
  children,
}) => {
  if (isPopupOpen) {
    return (
      <PopupWrapper open={isPopupOpen} size={size}>
        <PopupContainer alignItems={alignItems}>
          <InfoIconWrap color={themeColors.colorError}>
            <Info width="12px" height="12px" color={themeColors.colorError} />
          </InfoIconWrap>
          {title && <ModalTitle>{title}</ModalTitle>}
          {message && (
            <Paragraph centerText marginBottom={12}>
              {message}
            </Paragraph>
          )}
          {children}
        </PopupContainer>
      </PopupWrapper>
    );
  }
  return null;
};

ModalPopup.propTypes = {
  title: PropType.string,
  message: PropType.string,
  isPopupOpen: PropType.bool,
  alignItems: PropType.string,
  size: PropType.oneOf(['sm', 'md', 'lg']),
  children: PropType.node,
};

export default ModalPopup;
